import { api } from "./api";

export interface PlatformSettings {
  general?: {
    platformName?: string;
    platformDescription?: string;
    supportEmail?: string;
    contactPhone?: string;
    timezone?: string;
    language?: string;
  };
  registration?: {
    allowRegistration?: boolean;
    requireEmailVerification?: boolean;
    defaultRole?: string;
  };
  course?: {
    requireApproval?: boolean;
    maxCoursePrice?: number;
    minCoursePrice?: number;
  };
  payment?: {
    paymentEnabled?: boolean;
    paymentGateway?: string;
    platformFee?: number;
  };
  email?: {
    emailNotificationsEnabled?: boolean;
    sendWelcomeEmail?: boolean;
  };
  moderation?: {
    autoModerateContent?: boolean;
    requireContentApproval?: boolean;
  };
}

export const settingsApi = {
  // Get all settings (admin)
  getSettings: () => {
    return api.get<{ success: boolean; data: PlatformSettings }>("/settings");
  },

  // Get public settings
  getPublicSettings: () => {
    return api.get<{ success: boolean; data: any }>("/settings/public");
  },

  // Get single setting
  getSetting: (key: string) => {
    return api.get<{ success: boolean; data: any }>(`/settings/${key}`);
  },

  // Update single setting
  updateSetting: (key: string, value: any) => {
    return api.put<{ success: boolean; message: string }>(`/settings/${key}`, { value });
  },

  // Bulk update settings
  updateSettings: (settings: Record<string, any>) => {
    return api.post<{ success: boolean; message: string }>("/settings/bulk-update", { settings });
  },

  // Reset single setting
  resetSetting: (key: string) => {
    return api.put<{ success: boolean; message: string }>(`/settings/${key}/reset`);
  },

  // Initialize default settings
  initializeSettings: () => {
    return api.get<{ success: boolean; message: string }>("/settings/initialize");
  },
};